import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { Router } from '@angular/router';
import { AuthService } from '@app/services/auth/auth.service';

/**
 * @description Defines selector, templateUrl and encapsulation
 */
@Component({
    selector: 'app-home',
    template: '',
    encapsulation: ViewEncapsulation.None
})

/**
 * @description HomeComponent calls authentication and redirects to respective component
 * @export
 * @class HomeComponent
 * @implements {OnInit}
 */
export class HomeComponent implements OnInit {
    /**
     * @description it creates a instance of HomeComponent
     * @param auth
     */
    constructor(private readonly auth: AuthService,
        private router: Router) {
    }

    /**
    * @description ngOnInit() will load on initialization of this page
    * @memberof HomeComponent
    */
    ngOnInit(): void {
        if (this.router.url == '/proxy-login') {
            return
        }
        this.auth.startAuthentication();
    }
}
